import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import '../styles/segment-flair.css';

// Helper function to create a lighter version of a color for the background
const getLighterColor = (color) => {
  // For predefined colors, use the existing light color mapping
  const lightColorMap = {
    '#00A9E0': '#F1FBFE', // Primary
    '#92C911': '#F5FAE8', // Secondary
    '#E87722': '#FFF8F3', // Text
    '#CE0F69': '#FDF6FA', // Background
  };
  
  if (lightColorMap[color]) {
    return lightColorMap[color];
  }
  
  // For custom colors, return a semi-transparent version
  return `${color}20`; // 20% opacity
};

const SegmentFlair = ({ label, onClick, color }) => {
  // Create a style with lighter background and border color
  const flairStyle = {
    backgroundColor: getLighterColor(color),
    color: color,
    borderColor: color,
    border: `1px solid ${color}`
  };
  
  return (
    <Button 
      className="segment-flair"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      style={flairStyle}
      size="small"
    >
      {label}
    </Button>
  );
};

export const FlairDropdown = ({ flairs, onSelect }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleSelect = (flair) => {
    onSelect(flair.action);
    handleClose();
  };
  
  // Use the color of the first flair for the dropdown button
  const color = flairs && flairs.length > 0 ? flairs[0].color : '#00A9E0';
  const flairStyle = {
    backgroundColor: getLighterColor(color),
    color: color,
    borderColor: color,
    border: `1px solid ${color}`
  };
  
  return (
    <>
      <Button 
        className="segment-flair segment-flair-more"
        onClick={handleClick}
        size="small"
        style={flairStyle}
      >
        <MoreHorizIcon fontSize="small" />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
      >
        {flairs.map((flair, index) => (
          <MenuItem 
            key={index} 
            onClick={() => handleSelect(flair)}
            dense
          >
            {flair.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SegmentFlair;
